import { getResourceAllocationTotal } from './useResourceAllocationTotal';

const getAllocationsTotalForResourceRequest = ({
  me,
  resourceAllocations,
  contextCurrency
}) => {
  const allocationTotals = resourceAllocations.map(allocation =>
    getResourceAllocationTotal({
      me,
      contextCurrency,
      ...allocation
    })
  );

  const totalCost = {};

  allocationTotals.forEach(t => {
    const { currencyUri, currencySymbol } = t.resourceAllocationCost;

    if (currencyUri) {
      if (!totalCost[currencyUri])
        totalCost[currencyUri] = { currencySymbol, amount: 0 };

      totalCost[currencyUri].amount += t.resourceAllocationCost.amount;
    }
  });

  return {
    totalAllocatedHoursForResourceRequest: allocationTotals.reduce(
      (total, v) => total + v.resourceAllocationHours,
      0
    ),
    totalAllocatedCostForResourceRequest: Object.keys(totalCost).map(key => ({
      currencyUri: key,
      amount: totalCost[key].amount,
      currencySymbol: totalCost[key].currencySymbol
    }))
  };
};

export default getAllocationsTotalForResourceRequest;
